import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaNode, VolantinoDocument, VolantinoNode } from '@gql/graphql'
import CategoriaVolantiniTemplate from '@components/templates/CategoriaVolantiniTemplate/CategoriaVolantiniTemplate'

interface Props {
  pagina?: PaginaNode
  volantino?: VolantinoNode
}

const VolantinoDigitaleDetail = ({ pagina, volantino }: Props) => {
  return <CategoriaVolantiniTemplate pagina={pagina} volantino={volantino} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/volantini-digitali/[categoriaSlug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { categoriaSlug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { volantino },
    } = await client.query({
      query: VolantinoDocument,
      variables: { slug: categoriaSlug, preview },
      context: {
        headers,
      },
    })

    if (!volantino) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: volantino?.pagina,
        volantino: volantino,
      },
      revalidate: 60 * 20,
    }
  },
  '/volantini-digitali/[categoriaSlug]'
)

export default VolantinoDigitaleDetail
